
export const generateFixedLengthString = function (length) {
  let s = Math.random().toString(36).substr(2, Math.min(length, 10)).toUpperCase()
  if (length > 10) {
    s += generateFixedLengthString(length - 10)
  }
  return s
}

export const generateUUID = function () {
  return generateFixedLengthString(8) +
    '-' + generateFixedLengthString(4) +
    '-' + generateFixedLengthString(4) +
    '-' + generateFixedLengthString(4) +
    '-' + generateFixedLengthString(12)
}

export const isUrl = function (s) {
  var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/
  return regexp.test(s)
}

export const authorNames = function (authors) {
  let outStr = ''
  if (authors.length === 1) {
    outStr = authors[0]
  } else if (authors.length === 2) {
    outStr = authors.join(' and ')
  } else if (authors.length > 2) {
    outStr = authors.slice(0, -1).join(', ') + ', and ' + authors.slice(-1)
  }
  return outStr
}

export const scrollToTop = function () {
  document.querySelector('#goToTop').click()
}

export const scrollTo = function (hash) {
  if (hash) {
    let el = document.querySelector(hash)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    }
  } else {
    let el = document.querySelector('#app')
    el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js